<template>
  <div class="bg-white rounded p-12 shadow-lg">
    <h5 class="font-medium text-base">Are you sure you want to delete this payment?</h5>
    <div class="flex mt-8">
      <BaseButton danger :disabled="isLoading" @click="doDestroy"> Delete </BaseButton>

      <BaseButton ghost :disabled="isLoading" class="ml-auto md:ml-4" @click="doCancel">
        Cancel
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

const STATUS_IDLE = 'idle';
const STATUS_PENDING = 'pending';
const STATUS_RESOLVED = 'resolved';
const STATUS_REJECTED = 'rejected';

export default {
  props: {
    paymentUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      status: STATUS_IDLE,
      serverErrors: {},
      errorMessage: '',
    };
  },

  computed: {
    isLoading() {
      return this.status === STATUS_PENDING;
    },
    isResolved() {
      return this.status === STATUS_RESOLVED;
    },
    isRejected() {
      return this.status === STATUS_REJECTED;
    },
  },

  methods: {
    ...mapActions('admin/payments', {
      destroyPayment: 'destroy',
    }),

    async doDestroy() {
      if (this.isLoading) return;

      this.errorMessage = '';
      this.status = STATUS_PENDING;

      try {
        const { paymentUuid } = await this.destroyPayment({ paymentUuid: this.paymentUuid });

        this.status = STATUS_RESOLVED;

        this.$emit('payment-delete:deleted', paymentUuid);
      } catch (error) {
        this.status = STATUS_REJECTED;

        if (!error.response) {
          this.errorMessage = 'Something went wrong. Try again later';
        }
      }
    },

    doCancel() {
      if (this.isLoading) return;

      this.$emit('payment-delete:cancel');
    },
  },
};
</script>
